$(function () {
  // Textareas with countdown
  $('.js-minerva-form-textarea').each(function () {
    var $textarea = $(this).find('textarea'),
        $span = $(this).find(".js-minerva-form-textarea-countdown"),
        maxLength = parseInt($textarea.attr('maxlength'), 10);

    // init to maxlength
    $span.html(maxLength);

    // init countdown
    $span.html(maxLength - $textarea.val().length);

    // Update countdown
    $textarea.on('keyup keydown', function () {
      $span.html(maxLength - this.value.length);
    });
  });
});



// WEBPACK FOOTER //
// lib/js/minerva-form/textarea.js